export const data = [
    {
        id: 1,
        title: 'Подберём роутер',
        text: 'Рассчитаем площадь квартиры и&nbsp;дома так, чтобы сеть работала стабильно везде',
        bgImage1:  require('~/static/images/internet/represent/how-it-work/bg-1.png'),
        bgImageM:  require('~/static/images/internet/represent/how-it-work/bg-1m.png'),
        image: '',
        btnText: 'Выбрать роутер',
        btnHref: '/internet/equipment',
        isBottomText: false,
    },
    {
        id: 2,
        title: 'Перегрузки до 10G? Оборудование уже готово!',
        text: 'В&nbsp;2021 году мы&nbsp;обновили сеть и&nbsp;работаем на&nbsp;современном оборудовании, которое готово к&nbsp;большим нагрузкам',
        bgImage1:  require('~/static/images/internet/represent/how-it-work/bg-2.png'),
        bgImageM:  require('~/static/images/internet/represent/how-it-work/bg-2m.png'),
        isBottomText: true,
    },
    {
        id: 3,
        title: 'Круглосуточно проверяем качество связи',
        text: 'Современная система мониторинга позволит проверять соответствие качества скорости каждые 30&nbsp;сек',
        bgImage1: '',
        bgImage2: '',
        image: require('~/static/images/internet/represent/how-it-work/image-3.png'),
        isBottomText: true,
    },
    {
        id: 4,
        title: 'Сохраним ремонт',
        text: 'Спроектируем и&nbsp;проведём интернет без испорченных стен и&nbsp;проводов по&nbsp;всей квартире',
        bgImage1:  require('~/static/images/internet/represent/how-it-work/bg-4.png'),
        image: '',
    },
    {
        id: 5,
        title: 'Чат с&nbsp;поддержкой под рукой',
        text: 'Не&nbsp;нужно звонить и&nbsp;&laquo;висеть&raquo; на&nbsp;линии:' +
         ' пишите в&nbsp;чат прямо из&nbsp;приложения, в&nbsp;соцсети и&nbsp;мессенджеры&nbsp;&mdash; ответим!',
        image:  require('~/static/images/internet/represent/how-it-work/image-5.png'),
        isBottomText: true,
    },
    {
        id: 6,
        title: '«Мой Дом.ру» — приложение, в&nbsp;котором удобно',
        text: 'Управляйте тарифами, настройками, услугами со&nbsp;своего телефона',
        image:  require('~/static/images/internet/represent/how-it-work/image-6.png'),
    },
];
